export const RELEASE_INFO_ROW_LAYOUT = 'release_info_row_layout'
export const RELEASE_INFO_METADATA_IN_TRACKLIST =
  'release_info_metadata_in_tracklist'
export const AUTOPLAY_TOGGLE_TO_QUEUE = 'autoplay_toggle_to_queue'
export const RELEASE_QUICKVIEW_MODAL = 'release_quickview_modal'
export const NEW_PLAYBAR = 'new_playbar'
export const ARCHIVE_TO_FILTER = 'archive_to_filter'
export const PLAYER_PLAYLISTS = 'player_playlists'
export const RESPONSIVE_BREAKPOINTS_V2 = 'responsive_breakpoints_v2'
export const RESPONSIVE_BREAKPOINTS_V2_ROLLOUT =
  'responsive_breakpoints_v2_rollout'
